var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"typewriterElement",staticClass:"typewriter-element"},[_vm._v(_vm._s(_vm.currentText)+" "),(_vm.isAnimating)?_c('span',{staticClass:"blink"},[_vm._v("|")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }